import { render } from "./TechnicalIndicator.vue?vue&type=template&id=2fb20ee0"
import script from "./TechnicalIndicator.vue?vue&type=script&lang=js"
export * from "./TechnicalIndicator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__